import axios from 'axios'

const HTTP = axios.create({ 
  baseURL: location.protocol + '//' + process.env.VUE_APP_BACKEND_BASE_URL + '/' + process.env.VUE_APP_BACKEND_APP_NAME,
  headers: {
    'Content-Type': 'application/json',
    'x-ddol-apporg': 'eutils',
    'x-ddol-user': localStorage.getItem("user"),
    'x-ddol-org': localStorage.getItem("dominio"),
  }
})

HTTP.interceptors.request.use(
  function (config) {
    config.headers.common['x-ddol-security-token'] = localStorage.getItem("token")

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
HTTP.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default HTTP
